import { useSelector } from 'react-redux';
import {
  financialInstitutionIndia,
  sourceOfFundsIndia,
} from 'selectors/ui/india/ui';
import { MobileDetector } from 'utils/mobileDetector/mobileDetector';
import { useTranslations } from 'utils/translations/useTranslations';
import { sourceOfFundsIcons } from './hooks/useSourceOfFunds';

const SourceOfFundsHeader = () => {
  const i18n = useTranslations();
  const selectedSourceOfFunds = useSelector(sourceOfFundsIndia);
  const selectedFinancialInstitution = useSelector(financialInstitutionIndia);

  if (!selectedSourceOfFunds) {
    return null;
  }
  const Icon =
    sourceOfFundsIcons[
      selectedSourceOfFunds as keyof typeof sourceOfFundsIcons
    ];

  if (!Icon) {
    return null;
  }

  const isMobile = MobileDetector.isMobile();

  return (
    <div
      data-testid="selectedSourceOfFunds"
      className="border border-gray-300 border-t-0 sticky top-0 bg-white z-[1]"
    >
      <div className="flex items-center justify-center p-4 gap-x-2">
        <span className="text-gray-700 text-base text-start whitespace-pre">
          {i18n.t(
            isMobile
              ? 'sourceOfFunds.selected.mobile'
              : 'sourceOfFunds.selected',
          )}
        </span>
        {!isMobile && (
          <Icon
            data-testid="sourceOfFundsIcon"
            className="hidden md:inline-block w-6 h-auto"
          />
        )}
        <span className="text-gray-950 text-base font-medium col-span-2 whitespace-pre-wrap">
          {i18n.t(`sourceOfFunds.${selectedSourceOfFunds}.title`)}
        </span>
        {selectedFinancialInstitution && (
          <>
            ·
            <span className="text-gray-700 text-base text-start whitespace-pre hidden md:inline-block">
              {i18n.t('sourceOfFunds.financialInsitution.title')}
            </span>
            <span
              className="text-gray-950 text-base font-medium col-span-2 whitespace-pre-wrap"
              data-testid="selectedFinancialInstitution"
            >
              {i18n.t(
                `sourceOfFunds.financialInstitution.${selectedFinancialInstitution}`,
              )}
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export { SourceOfFundsHeader };
